export default __webpack_public_path__ + "static/DocUpWhite-0f8927b986290812edf832f471b138a9.png";